import getConfig from 'next/config';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export type Variables = { [key: string]: any };
export type RequestOptions = AxiosRequestConfig;

export interface GraphQLRequest<V> {
  query: string,
  variables?: V,
}

export interface GraphQLClient {
  query<T = any, V = Variables>(request: GraphQLRequest<V>): Promise<{ data: T }>,
}

let graphQlClient: GraphQLClient = null;

class GraphQLClientImpl implements GraphQLClient {
  private url: string;

  private options: RequestOptions;

  constructor(url: string, options?: RequestOptions) {
    this.url = url;
    this.options = options || {};
  }

  async query<T = any, V = Variables>(request: GraphQLRequest<V>): Promise<{ data: T }> {
    const body = JSON.stringify(request);

    // unwrap from axios 'data' and use only graphql 'data'
    return axios.post<{ data: T }>(this.url, body, this.options)
      .then((response: AxiosResponse<{ data: T }>) => response.data);
  }
}

function create() {
  const {
    publicRuntimeConfig: {
      GRAPHCMS_URL,
      GRAPHCMS_AUTH_TOKEN,
    },
  } = getConfig();

  return new GraphQLClientImpl(GRAPHCMS_URL, {
    headers: {
      Authorization: GRAPHCMS_AUTH_TOKEN ? `Bearer ${GRAPHCMS_AUTH_TOKEN}` : '',
    },
  });
}

export default function initGraphQLClient() {
  if (!graphQlClient) {
    graphQlClient = create();
  }

  return graphQlClient;
}
